<template>
  <component :is="icon" class="svg-icon"></component>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      icons: {},
    };
  },
  computed: {
    icon() {
      return this.icons[this.name];
    },
  },
  beforeMount() {
    if (typeof this.icons[this.name] !== "object") {
      throw new TypeError(`The SVG icon with the specified name "${this.name}" couldn't be found.`);
    }
  },
});
</script>

<style lang="scss" scoped>
@import "@scss/includes/framework.scss";

.svg-icon {
  width: auto;
  height: auto;
  display: inline-block;
  vertical-align: middle;
}
</style>
